import React, { Component } from 'react'

const BLOCK_NAME = 'admin-actions-list'

export const AdminActionsList = ({ actions }) =>
  <ul className={BLOCK_NAME}>
    {actions.map(action =>
      <li key={action.name}>
        <button className={`${BLOCK_NAME}__action`} onClick={action.onClick}>
          {action.name}
        </button>
      </li>
    )}
  </ul>



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/admin_panel/AdminActionsList.view.js